// import './highway/highway-core';
import './src/responsive-images';
import './src/sliders';
import './src/maps';
import './src/menu';
import './src/ie-links';
import './src/animations';
import './src/contact-map';
import './src/home-animation';
import './src/load-more';



// WEBPACK FOOTER //
// ./assets/js/main.js